

















import { defineComponent, toRefs, PropType } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { useAdgroupBiddingValidate } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';

import BillingEvent from './index';

const name = 'ttam-billing-event-compose';
export default defineComponent({
  name,
  components: {
    TtamBillingEventLabel: BillingEvent.TtamBillingEventLabel,
    TtamBillingEventLabelHint: BillingEvent.TtamBillingEventLabelHint,
    TtamBillingEventText: BillingEvent.TtamBillingEventText,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props) {
    const { adgroupData, campaignData } = toRefs(props);
    const { billingEvent } = BillingEvent.useTextPropsBillingEvent({ adgroupData, campaignData });

    const { pricingValidator } = useAdgroupBiddingValidate({
      campaignFormData: campaignData,
    });

    const iconHoverTrack = () => trackEvent('adgroup_billing_hint_hover');

    return {
      name,
      billingEvent,
      pricingValidator,
      iconHoverTrack,
    };
  },
});
